import { Button as ButtonMUI, ButtonOwnProps } from '@mui/material';
import React from 'react';

interface IButtonRequired {
  children: React.ReactNode;
}

interface IButtonOptional {
  variant?: 'text' | 'outlined' | 'contained';
  type?: 'submit' | 'reset' | 'button';
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  buttonStyle?: string;
  tabIndex?: number;
  sx?: Record<string, unknown>;
  fullWidth?: boolean;
}

interface IButtonProps extends IButtonRequired, IButtonOptional {}

const Button: React.ForwardRefExoticComponent<
  IButtonProps & React.RefAttributes<HTMLButtonElement | null> & ButtonOwnProps
> = React.forwardRef(
  (
    {
      variant = 'contained',
      type = 'button',
      buttonStyle = '',
      disabled = false,
      onClick = () => {},
      children,
      tabIndex = 0,
      sx = {},
      fullWidth = true,
      ...props
    }: IButtonProps,
    ref
  ) => (
    <ButtonMUI
      ref={ref}
      type={type}
      variant={variant}
      className={buttonStyle}
      disabled={disabled}
      onClick={onClick}
      tabIndex={tabIndex}
      fullWidth={fullWidth}
      sx={{
        textTransform: 'none',
        borderRadius: '360px',
        fontSize: '16px',
        ...sx,
      }}
      {...props}
    >
      {children}
    </ButtonMUI>
  )
);

Button.displayName = 'Btn';

export default React.memo(Button);
